import { SET_NAMED_PARTY_SORT_ORDER } from '../types';

const setNamedParty = sortOrder => {
  return {
    type: SET_NAMED_PARTY_SORT_ORDER,
    payload: {
      sortOrder,
    },
  };
};

export default setNamedParty;
